module.exports = __webpack_public_path__ + "static/media/img_car_1_desktop.9930e766.webp";